define('xlsxloader',['jszip'], function (jszip) {
    "use strict";

    window.JSZip = jszip;
});
